import { render, staticRenderFns } from "./goods_detail.vue?vue&type=template&id=166ef33a&scoped=true"
import script from "./goods_detail.vue?vue&type=script&lang=js"
export * from "./goods_detail.vue?vue&type=script&lang=js"
import style0 from "./goods_detail.vue?vue&type=style&index=0&id=166ef33a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ef33a",
  null
  
)

export default component.exports